module.exports = __webpack_public_path__ + "static/ExsisCorporativosubtitulado-9cdbf4ae31418146f265c270fd2b2e99.mp4";